import { render, staticRenderFns } from "./MrNewsletterSubscription.vue?vue&type=template&id=220733d8&lang=pug"
import script from "./MrNewsletterSubscription.vue?vue&type=script&lang=js"
export * from "./MrNewsletterSubscription.vue?vue&type=script&lang=js"
import style0 from "./MrNewsletterSubscription.vue?vue&type=style&index=0&id=220733d8&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports